import type { EChartsOption } from 'echarts';

type EchartsFontWeight = number | 'normal' | 'bold' | 'bolder' | 'lighter';
type EchartsGraphicElement<Graphic = NonNullable<EChartsOption['graphic']>> =
  Graphic extends Array<infer Element> ? Element : Graphic;

export interface EchartsCenterTotalGraphicOptions {
  title: string;
  total: number | string;
  top?: string;
  titleFontSize?: number;
  titleFontWeight?: EchartsFontWeight;
  titleOffsetY?: number;
  totalFontSize?: number;
  totalOffsetY?: number;
}

export function createEchartsCenterTotalGraphic({
  title,
  total,
  top = '50%',
  titleFontSize = 14,
  titleFontWeight = 600,
  titleOffsetY = -14,
  totalFontSize = 24,
  totalOffsetY = 14,
}: EchartsCenterTotalGraphicOptions): EchartsGraphicElement {
  return {
    type: 'group',
    left: '50%',
    top,
    bounding: 'raw',
    silent: true,
    children: [
      {
        type: 'text',
        x: 0,
        y: titleOffsetY,
        style: {
          text: title,
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
          fill: '#0F204B',
          align: 'center',
          verticalAlign: 'middle',
        },
      },
      {
        type: 'text',
        x: 0,
        y: totalOffsetY,
        style: {
          text: String(total),
          fontSize: totalFontSize,
          fontWeight: 'bold' as const,
          fill: '#003591',
          align: 'center',
          verticalAlign: 'middle',
        },
      },
    ],
  };
}
